var mp = mp || {};

// Form - Contact
//----------------------------------------------------------
mp.formValidationContact = function() {
    var $element = $('#form--contact');

    if (!$element.length) {
        return;
    }

    $element.validate({
        errorPlacement: function(error, element) {},
        ignore: ".ignore",
        rules: {
            "name": {
                required: true
            },
            "email": {
                required: true,
                email: true
            },
            "message": {
                required: true
            },
        },
        submitHandler: function(form) {
            mp.loadingOverlay("show");

            $.ajax({
                url: form.action,
                type: form.method,
                data: $(form).serialize(),
                success: function(response) {
                    if (response=="success") {
                        form.reset();
                        grecaptcha.reset();

                        mp.loadingOverlay("hide");
                        mp.popupSuccess();
                    } else {
                        grecaptcha.reset();

                        mp.loadingOverlay("hide");
                        mp.popupError();
                    }
                }            
            });
        }
    });
};



$(document).ready(function (){
    mp.formValidationContact();
});